import TaTransactionOrderCardPolicy from './TaTransactionOrderCardPolicy'

export default TaTransactionOrderCardPolicy
